import React from 'react';
import './Pricing_Boxes.css';
import { HiBadgeCheck } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';

const Pricing_Boxes = () => {
  const { t, i18n } = useTranslation();

  const pricingData = [
    {
      titleKey: 'pricing_plan_1week_title',
      descKey: 'pricing_plan_1week_desc',
      features: [
        'undetected_pricing',
        'custom_build',
        'hotkeys_pricing',
        'updates_support',
        'anti_afk_pricing',
      ],
      linkEn: "https://www.oplata.info/asp2/pay_wm.asp?id_d=5198867&lang=en-EN",
      linkRu: "https://www.oplata.info/asp2/pay_wm.asp?id_d=5239301&lang=ru-RU",
      androidLink: "https://oplata.info/asp2/pay_wm.asp?id_d=5654663&lang=en-EN"
    },
    {
      titleKey: 'pricing_plan_1month_title',
      descKey: 'pricing_plan_1month_desc',
      features: [
        'undetected_pricing',
        'custom_build',
        'hotkeys_pricing',
        'updates_support',
        'anti_afk_pricing',
      ],
      linkEn: "https://www.oplata.info/asp2/pay_wm.asp?id_d=5198892&lang=en-EN",
      linkRu: "https://www.oplata.info/asp2/pay_wm.asp?id_d=5239314&lang=ru-RU",
      androidLink: "https://oplata.info/asp2/pay_wm.asp?id_d=5654665&lang=en-EN"
    },
    {
      titleKey: 'pricing_plan_3months_title',
      descKey: 'pricing_plan_3months_desc',
      features: [
        'undetected_pricing',
        'custom_build',
        'hotkeys_pricing',
        'updates_support',
        'anti_afk_pricing',
      ],
      linkEn: "https://www.oplata.info/asp2/pay_wm.asp?id_d=5198901&lang=en-EN",
      linkRu: "https://www.oplata.info/asp2/pay_wm.asp?id_d=5239309&lang=ru-RU",
      androidLink: "https://oplata.info/asp2/pay_wm.asp?id_d=5654667&lang=en-EN"
    },
  ];

  const getLink = (plan) =>
    i18n.language === 'ru' ? plan.linkRu : plan.linkEn;

  return (
    <div className="pricing-boxes-component">
      {/* Pricing Wrapper */}
      <div className="pricing-boxes-wrapper">
        <div className="pricing-boxes-inner">
          {pricingData.map((plan, idx) => {
            const parts = t(plan.descKey).split('/');
            const price = parts[0].trim();
            const period = parts[1] ? parts[1].trim() : '';
            return (
              <div key={idx} className="pricing-boxes-box">
                <div className="pricing-box-content">
                  <h3>{t(plan.titleKey)}</h3>
                  <p className="pricing-boxes-description">
                    <span className="price-number">{price}</span>
                    {period && <span className="pricing-boxes-period"> / {period}</span>}
                  </p>
                  <div className="pricing-boxes-features">
                    {plan.features.map((fKey, i) => (
                      <div key={i} className="pricing-boxes-feature">
                        <HiBadgeCheck className="feature-icon" />
                        <span>{t(fKey)}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="pricing-box-buttons">
                  <a href={plan.androidLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <button className="pricing-boxes-button hardware-button button-with-tag">
                      <span className="new-tag">NEW</span>
                      <span className="hardware-main-text">Purchase Android Version</span>
                      <span className="hardware-sub-text">MAKCU + Android Phone/Tablet</span>
                    </button>
                  </a>
                  <a href={getLink(plan)} target="_blank" rel="noopener noreferrer" style={{ marginTop:'2px', textDecoration: 'none' }}>
                    <button className="pricing-boxes-button hardware-button">
                      <span className="hardware-main-text">{t('purchase_hardware')}</span>
                      <span className="hardware-sub-text">MAKCU + 2PC or Raspberry Pi</span>
                    </button>
                  </a>
                </div>
              </div>
            );
          })}
          {/* Lifetime Access Box */}
          <div className="pricing-boxes-box lifetime-box">
            <div className="pricing-box-content">
              <h3 className="lifetime-access-title">{t('lifetime_access')}</h3>
              {i18n.language === 'ru' ? (
                <p className="lifetime-original-price">7000 ₽</p>
              ) : (
                <p className="lifetime-original-price">{t('lifetime_original_price')}</p>
              )}
              {i18n.language === 'ru' ? (
                <p className="pricing-boxes-description">
                  <span className="price-number">4000 ₽</span>{' '}
                  <span className="limited-offer">{t('limited_offer')}</span>
                </p>
              ) : (
                <p className="pricing-boxes-description">
                  <span className="price-number">50$</span>{' '}
                  <span className="limited-offer">{t('limited_offer')}</span>
                </p>
              )}
              <div className="lifetime-text" dangerouslySetInnerHTML={{ __html: t('lifetime_text') }}></div>
            </div>
            <div className="pricing-box-buttons">
              <a
                href="https://oplata.info/asp2/pay_wm.asp?id_d=5654670&lang=en-EN"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <button className="pricing-boxes-button hardware-button button-with-tag">
                  <span className="new-tag">NEW</span>
                  <span className="hardware-main-text">Purchase Android Version</span>
                  <span className="hardware-sub-text">MAKCU + Android Phone/Tablet</span>
                </button>
              </a>
              <a
                href={
                  i18n.language === 'ru'
                    ? "https://www.oplata.info/asp2/pay_wm.asp?id_d=5239315&lang=ru-RU"
                    : "https://www.oplata.info/asp2/pay_wm.asp?id_d=5200323&lang=en-EN"
                }
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginTop:'2px', textDecoration: 'none' }}
              >
                <button className="pricing-boxes-button hardware-button">
                  <span className="hardware-main-text">{t('purchase_hardware')}</span>
                  <span className="hardware-sub-text">MAKCU + 2PC or Raspberry Pi</span>
                </button>
              </a>
            </div>
          </div>
        </div> {/* End of .pricing-boxes-inner */}
      </div> {/* End of .pricing-boxes-wrapper */}
    </div>
  );
};

export default Pricing_Boxes;
